/** Single client preference from GET/PATCH `/client/preferences`. */
export interface ClientPreferenceItem {
  key: string;
  promptForValue?: boolean;
  booleanValue?: boolean;
  numericValue?: number;
  stringValue?: string;
}

/** PATCH body item for `/client/preferences`. */
export interface ClientPreferencePatchItem {
  key: string;
  booleanValue?: boolean;
  numericValue?: number;
  stringValue?: string;
}

export interface ClientPreferencesPayload {
  payload: ClientPreferenceItem[];
}

/** Known marketing consent keys from `/client/preferences`. */
export const CLIENT_PREFERENCE_KEYS = {
  smsMarketingConsent: 'smsMarketingConsent',
  emailMarketingConsent: 'emailMarketingConsent',
} as const;

export type ClientMarketingPreferenceKey =
  (typeof CLIENT_PREFERENCE_KEYS)[keyof typeof CLIENT_PREFERENCE_KEYS];

export const CLIENT_MARKETING_PREFERENCE_KEYS: readonly ClientMarketingPreferenceKey[] = [
  CLIENT_PREFERENCE_KEYS.smsMarketingConsent,
  CLIENT_PREFERENCE_KEYS.emailMarketingConsent,
];
